import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const Footer = () => {
  const isAdminPage = window.location.pathname.startsWith("/admin");
  const isChopNation = window.location.pathname === "/dining";
  
  if (isAdminPage || isChopNation) return null;

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={`${styles.footerSection} ${styles.footerLogoSection}`}>
          <div className={styles.footerLogo}>
            <img src="/images/logoBackground.png" alt="Aurelia Logo" />
          </div>
          <p className={styles.footerDescription}>
            Experience luxury redefined at Aurelia - where elegance meets
            comfort in the heart of Abuja.
          </p>
        </div>

        <div className={`${styles.footerSection} ${styles.footerLinks}`}>
          <h4>Quick Links</h4>
          <ul>
            <li>
              <Link to="/residencies">Rooms</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <span className={styles.disabledLink} aria-disabled="true" tabIndex={-1} style={{ pointerEvents: "none", color: "#aaa" }}>
                Services
              </span>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        <div className={`${styles.footerSection} ${styles.footerLegal}`}>
          <h4>Legal</h4>
          <ul>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/privacy-rights">Your Privacy Rights</Link>
            </li>
            <li>
              <Link to="/privacy-rights">Data Protection Rights</Link>
            </li>
            <li>
              <Link to="/terms-of-service">Terms of Service</Link>
            </li>
          </ul>
        </div>

        <div className={`${styles.footerSection} ${styles.footerServices}`}>
          <h4>Our Services</h4>
          <ul>
            <li>Luxury Accommodations</li>
            <li>Airport Pickup</li>
            <li>24/7 Concierge</li>
            <li>
              <Link to="/dining" style={{ color: "inherit", textDecoration: "none" }}>Room Service & Ordering</Link>
            </li>
          </ul>
        </div>

        <div className={`${styles.footerSection} ${styles.footerContact}`}>
          <h4>Contact Info</h4>
          <div className={styles.contactInfo}>
            <div className={styles.contactItem}>
              <span className={styles.contactLabel}>Address:</span>
              <span>
                2 Bukar Dipcharima close off Teslim Elias street off TOS Benson
                Street Utako Abuja
              </span>
            </div>
            <div className={styles.contactItem}>
              <span className={styles.contactLabel}>Phone:</span>
              <span>+2348165028212</span>
              <span>+2349152304757</span>
            </div>
            <div className={styles.contactItem}>
              <span className={styles.contactLabel}>Email:</span>
              <span className="">info@aurelia-apartments.com</span>
              <span>sales@aurelia-apartments.com</span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <div className={styles.footerCopyright}>
          <p>&copy; 2025 Aurelia Luxury Residences. All rights reserved | Site by Eiza Innovations Limited</p>
          <p className={styles.privacyNotice}>
            We use cookies to enhance your experience. By continuing to use our site, you agree to our use of cookies as described in our{' '}
            <Link to="/privacy-policy" className={styles.privacyLink}>Privacy Policy</Link>.
          </p>
        </div>
        <div className={styles.footerSocial}>
          <a href="#" aria-label="Facebook">
            FB
          </a>
          <a href="#" aria-label="Instagram">
            IG
          </a>
          <a href="#" aria-label="Twitter">
            TW
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
